// @ts-check
import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

/** @typedef {import("./types/release.types").Release} Release */

/** @type {React.Context<{ release: Release | null }>} */
const ReleaseContext = createContext({ release: null });

export const ReleaseProvider = ({ children, release }) => {
  // Memoise the value object to prevent unnecessary re-renders - will only update if release changes
  /** @type {{ release: Release | null }} */
  const value = useMemo(
    () => ({ release }),
    [release]
  );

  return (
    <ReleaseContext.Provider value={value}>{children}</ReleaseContext.Provider>
  );
};

ReleaseProvider.propTypes = {
  children: PropTypes.node,
  release: PropTypes.shape({
    release_id: PropTypes.number,
    version_id: PropTypes.string,
    last_update: PropTypes.string,
    creation_date: PropTypes.string,
    release_status: PropTypes.string,
    presentation_name: PropTypes.string,
    isCurrentRelease: PropTypes.bool,
    release_end: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),    // null if isCurrentRelease to avoid issues with stale 'now' due to memoisation
  }),
};

/** @returns {{ release: Release | null }} */
export const useReleaseContext = () => useContext(ReleaseContext);